"use es6";

import Raven from 'raven-js';
const identity = stuff => stuff;
export default function createMiddleware(cfg = {}, options = {}) {
  /*
    Function that generates a crash reporter for Sentry.
    cfg - object to configure Raven.
    options - customize extra data sent to sentry
      actionTransformer - tranform the action object to send; default to identity function
      logger - the logger to use for logging; default to console.error
  */
  return store => next => action => {
    const {
      actionTransformer = identity,
      logger = console.error.bind(console, "[redux-raven-middleware] Reporting error to Sentry:")
    } = options;
    const {
      type,
      payload
    } = action;
    // Do not report sentries for XHRs unless it's a 400
    if (type.indexOf("_FAILURE") !== -1 && payload && payload.error && (!payload.error.xhr || payload.error.status === 400)) {
      Raven.captureException(payload.error, {
        extra: {
          actionType: type
        }
      });
    }
    try {
      Raven.captureBreadcrumb({
        category: "redux",
        message: action.type
      });
      return next(action);
    } catch (err) {
      logger(err);

      // Send the report.
      Raven.captureException(err, {
        extra: {
          action: actionTransformer(action)
        }
      });
    }
  };
}